import type { InventoryListResponse } from '@/types/Api/Inventory'
import type { InventoryTransaction } from '@/types/Models/InventoryTransaction'
import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class InventoryTransactionsProxy
  extends BaseProxy
  implements ProxyMethods<InventoryListResponse<InventoryTransaction>>
{
  public endpoint = 'transactions'
  public hostname = import.meta.env.VITE_APP_INVENTORY_API

  all(): Promise<InventoryListResponse<InventoryTransaction>> {
    return this.submit('get', `${this.hostname}/${this.endpoint}`)
  }
}
